import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles, Dialog, DialogTitle, IconButton,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';

import CloseIcon from '@material-ui/icons/CloseRounded';
import EventOverlapWarning from './EventOverlapWarning';

import { EditEventStyle } from './EditEvent.style';
import EditEvent from './EditEvent';
import { DialogTop } from '@components/economy/DialogComponens';
import { IEvent } from '@app-types/websocket/event.types';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  creator:number;
  overlaps:IEvent[];
}

interface IProps extends WithStyles<typeof EditEventStyle> {
  close:() => void;
  open:boolean;
  onDate:Date|undefined;
}

class CreateEvent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);


    this.state = {
      creator:0,
      overlaps:[],
    };
  }

  public render() {
    const {overlaps} = this.state;

    return (
      <Dialog
        open={ this.props.open}
        onClose={() => this.props.close()}
        classes={{paper:this.props.classes.bigDialog}}
      >
        <DialogTop>
          <DialogTitle>{tn.lang.calNewEvent}</DialogTitle>
          <IconButton onClick={() => this.props.close()}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <div style={{position:'relative', overflow: 'hidden', display: 'flex', flexDirection: 'column'}}>
          <div style={{position:'relative', display:'flex', flex:1, minHeight:0}}>
            <EditEvent
              close={() => this.props.close()}
              event={undefined}
              onDate={this.props.onDate}
              onOverlapsChange={this.handleOverlaps}
            />
          </div>
          <EventOverlapWarning overlaps={overlaps} />
        </div>
      </Dialog>
    );
  }

  private handleOverlaps = (overlaps:IEvent[]) => this.setState({overlaps});
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
  };
}

export default connect(mapStateToProps)(withStyles(EditEventStyle)(CreateEvent));



// WEBPACK FOOTER //
// ./src/components/calendar2/eventdetails/CreateEvent.tsx